/** Towns for browse-by-town (Local Jobs NENW region). */
export const TOWNS = [
  { slug: 'tamworth', name: 'Tamworth' },
  { slug: 'armidale', name: 'Armidale' },
  { slug: 'moree', name: 'Moree' },
  { slug: 'narrabri', name: 'Narrabri' },
  { slug: 'gunnedah', name: 'Gunnedah' },
  { slug: 'inverell', name: 'Inverell' },
  { slug: 'glen-innes', name: 'Glen Innes' },
  { slug: 'walcha', name: 'Walcha' },
  { slug: 'tenterfield', name: 'Tenterfield' },
  { slug: 'liverpool-plains', name: 'Liverpool Plains' },
  { slug: 'uralla', name: 'Uralla' },
  { slug: 'regional', name: 'Regional-wide' },
] as const;

export type TownSlug = (typeof TOWNS)[number]['slug'];

/** Match event location to town (slug or name). */
export function locationMatchesTown(location: string | null, townSlug: string): boolean {
  if (!location || !townSlug) return false;
  if (townSlug === 'regional') return true;
  const loc = location.toLowerCase();
  const slugToName: Record<string, string> = {
    tamworth: 'tamworth',
    armidale: 'armidale',
    moree: 'moree',
    narrabri: 'narrabri',
    gunnedah: 'gunnedah',
    inverell: 'inverell',
    'glen-innes': 'glen innes',
    walcha: 'walcha',
    tenterfield: 'tenterfield',
    'liverpool-plains': 'liverpool plains',
    uralla: 'uralla',
  };
  const name = slugToName[townSlug];
  return name ? loc.includes(name) : false;
}
